import { render } from "./ExhibitorsProfile.vue?vue&type=template&id=380b8acc&scoped=true"
import script from "./ExhibitorsProfile.vue?vue&type=script&lang=js"
export * from "./ExhibitorsProfile.vue?vue&type=script&lang=js"

import "./ExhibitorsProfile.vue?vue&type=style&index=0&id=380b8acc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-380b8acc"]])

export default __exports__